import { AnyAction } from '@reduxjs/toolkit'

import { ADD_USER_SUCCESS } from '@/pages/OrganizationUserEditPage/actionTypes'

import {
  DELETE_USER_SUCCESS,
  FETCH_ORG_USERS_SUCCESS,
  RESET_ORG_USERS_PAGINATION_STATE,
  SET_EDIT_ORG_USER,
  SET_FILTER_ORG_USER,
  SET_ORG_USERS_SORTING_STATE
} from './actionTypes'

type OrganizationUsersPageState = {
  page: any[]
  filter: string
  totalUsers?: number
  startIndex?: number
  sortingColumn?: unknown
  isEditingUser?: boolean
}

const initialState: OrganizationUsersPageState = { page: [], filter: '' }

export default (state = initialState, action: AnyAction): OrganizationUsersPageState => {
  switch (action.type) {
    case FETCH_ORG_USERS_SUCCESS: {
      if (action.response) {
        return {
          ...state,
          page: action.response.resources.map(({ id }: { id: string }) => id),
          totalUsers: action.response.totalResults,
          startIndex: action.response.startIndex
        }
      } else {
        return { ...state, page: [] }
      }
    }

    case SET_FILTER_ORG_USER: {
      return { ...state, filter: action.filter }
    }

    case SET_ORG_USERS_SORTING_STATE: {
      return { ...state, sortingColumn: action.sortingColumn }
    }

    case SET_EDIT_ORG_USER: {
      return { ...state, isEditingUser: action.isEditingUser }
    }

    case RESET_ORG_USERS_PAGINATION_STATE:
    case DELETE_USER_SUCCESS:
    case ADD_USER_SUCCESS: {
      return { ...state, sortingColumn: null, startIndex: 1, totalUsers: 0, page: [], isEditingUser: false, filter: '' }
    }

    default: {
      return state
    }
  }
}
